import { fork } from 'redux-saga/effects';
import categorySagas from './category';
import quizSagas from './quiz';
import quizBuilderSagas from './quiz_builder';
import folderSagas from './folder';
import tagSagas from './tag';
import quizSessionSagas from './quiz_session';
import userSagas from './user';
import configSagas from './config';

export default function* root() {
  yield fork(configSagas);
  yield fork(quizSagas);
  yield fork(quizBuilderSagas);
  yield fork(categorySagas);
  yield fork(folderSagas);
  yield fork(tagSagas);
  yield fork(userSagas);
  yield fork(quizSessionSagas);
}
